import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import type { OrderHistoryOrderFragment } from '../../__graphql__/OrderHistory';
import {
  ELIGIBLE_FOR_RETURN_PERIOD,
  ORDER_RETURN_EXCLUDED_STATUSES,
} from '../constants';

export function useShowReturnHandler(
  order: Pick<OrderHistoryOrderFragment, 'orderDate' | 'statusCode' | 'items'>,
) {
  if (!order.orderDate || !order.statusCode || !order.items) {
    return { showReturnHandler: false };
  }

  const isWithinReturnPeriod =
    differenceInCalendarDays(Date.now(), new Date(order.orderDate)) <
    ELIGIBLE_FOR_RETURN_PERIOD;

  const hasEligibleOrderStatus = !ORDER_RETURN_EXCLUDED_STATUSES.includes(
    order.statusCode,
  );

  const hasEligibleForReturnProducts = order.items.some(
    (item) => item?.eligibleForReturn,
  );

  const showReturnHandler = [
    isWithinReturnPeriod,
    hasEligibleOrderStatus,
    hasEligibleForReturnProducts,
  ].every(Boolean);

  return { showReturnHandler };
}
